// Matches logic in React's `shared/ExecutionEnvironment` file
// https://github.com/facebook/react/blob/9cdf8a99edcfd94d7420835ea663edca04237527/packages/shared/ExecutionEnvironment.js

export const canUseWindow = !!(
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
)
